import React, { useEffect } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Box, Link, Typography } from '@mui/material';
import MarqitLogoFull from '../components/MarqitLogoFull';
import LegalFooter from '../components/LegalFooter';
import { LEGAL_DOCS } from '../legal/documents';
import { LEGAL_VERSION } from '../constants/company';

// Public page with one legal document (offer, privacy policy, consent, requisites); no sign-in needed.
const LegalPage = ({ doc }) => {
  const d = LEGAL_DOCS[doc];
  useEffect(() => { document.title = `${d.title} — MARQIT`; }, [d.title]);

  return (
    <Box sx={{ minHeight: '100vh', background: 'linear-gradient(145deg, #EAFBFA 0%, #DFF7F6 40%, #f0fafa 100%)', py: { xs: 2, sm: 5 }, px: 2 }}>
      <Box sx={{
        maxWidth: 820, mx: 'auto', background: '#fff', borderRadius: '24px',
        boxShadow: '0 24px 80px rgba(25,198,192,0.12), 0 4px 16px rgba(0,0,0,0.06)',
        border: '1px solid rgba(25,198,192,0.1)', p: { xs: 2.5, sm: 5 },
      }}>
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: 2, mb: 3 }}>
          <RouterLink to="/login" aria-label="На главную"><MarqitLogoFull width={170} /></RouterLink>
          <Link component={RouterLink} to="/login" sx={{ fontWeight: 600, color: '#11BDB6', fontSize: '0.875rem' }}>Войти в сервис</Link>
        </Box>
        <Typography component="h1" sx={{ fontSize: { xs: '1.5rem', sm: '1.875rem' }, fontWeight: 800, color: '#111827' }}>{d.title}</Typography>
        <Typography sx={{ color: '#6B7280', mt: 0.5, mb: 3, fontSize: '0.9375rem' }}>
          {d.subtitle} · редакция от {LEGAL_VERSION.split('-').reverse().join('.')}
        </Typography>
        {d.sections.map((s, i) => (
          <Box key={i} sx={{ mb: 2.5 }}>
            {s.h && <Typography component="h2" sx={{ fontSize: '1.0625rem', fontWeight: 700, color: '#111827', mb: 1 }}>{s.h}</Typography>}
            {s.p.map((t, j) => (
              <Typography key={j} sx={{ fontSize: '0.9375rem', lineHeight: 1.65, color: '#374151', mb: 0.75 }}>{t}</Typography>
            ))}
          </Box>
        ))}
      </Box>
      <LegalFooter sx={{ mt: 3 }} />
    </Box>
  );
};

export default LegalPage;
